"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var acorn_1 = require("acorn");
var visitors_1 = require("./visitors");
var errorTypes_1 = require("./errorTypes");
var syntaxTypes = {
    Program: 3,
    ExpressionStatement: 3,
    IfStatement: 3,
    FunctionDeclaration: 3,
    VariableDeclaration: 3,
    ReturnStatement: 3,
    CallExpression: 3,
    UnaryExpression: 3,
    BinaryExpression: 3,
    LogicalExpression: 3,
    ConditionalExpression: 3,
    FunctionExpression: 3,
    Identifier: 3,
    Literal: 3
};
var compose = function compose(v1, v2) {
    return function (parent, node) {
        v1(parent, node);
        v2(parent, node);
    };
};
var counter = 0;
exports.freshId = function () {
    counter++;
    return "__node" + counter;
};
var defineVariable = function defineVariable(identifier, state) {
    if (state.frames[0][identifier.name]) {
        state.errors.push({
            type: errorTypes_1.ErrorType.VariableRedeclaration,
            node: identifier
        });
    } else {
        state.frames[0][identifier.name] = {
            name: identifier.name,
            loc: identifier.loc
        };
    }
};
var isVariableDefined = function isVariableDefined(name, state) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = state.frames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var frame = _step.value;

            if (frame.hasOwnProperty(name)) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return false;
};
var createVisitors = function createVisitors(week, state) {
    var visitors = {
        onError: function onError(error, parent, node) {
            state.errors.push({
                type: error,
                node: node
            });
        }
    };
    var allowedTypes = getAllowedSyntaxTypes(week);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = allowedTypes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var type = _step2.value;

            visitors[type] = {
                before: function before(parent, node) {
                    state.node = node;
                    node.__id = exports.freshId();
                },
                after: visitors_1.noop
            };
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    visitors.IfStatement.before = compose(visitors.IfStatement.before, function (parent, node) {
        if (node.consequent && node.consequent.type !== 'BlockStatement') {
            state.errors.push({
                type: errorTypes_1.ErrorType.IfConsequentNotABlockStatement,
                node: node
            });
        }
        if (!node.alternate) {
            state.errors.push({
                type: errorTypes_1.ErrorType.MissingIfAlternate,
                node: node
            });
        } else if (node.alternate && node.alternate.type !== 'BlockStatement') {
            state.errors.push({
                type: errorTypes_1.ErrorType.IfAlternateNotABlockStatement,
                node: node
            });
        }
    });
    visitors.BinaryExpression.before = compose(visitors.BinaryExpression.before, function (parent, node) {
        if (node.operator === '==') {
            state.errors.push({
                type: errorTypes_1.ErrorType.UseStrictEquality,
                node: node
            });
        } else if (node.operator === '!=') {
            state.errors.push({
                type: errorTypes_1.ErrorType.UseStrictInequality,
                node: node
            });
        }
    });
    visitors.VariableDeclaration.after = compose(function (parent, node) {
        var identifier = node.declarations[0].id;
        defineVariable(identifier, state);
    }, visitors.VariableDeclaration.after);
    visitors.FunctionDeclaration.before = compose(visitors.FunctionDeclaration.before, function (parent, node) {
        defineVariable(node.id, state);
        var frame = {};
        state.environments[node.id.name] = frame;
        node.params.forEach(function (p) {
            var ident = p;
            frame[ident.name] = {
                name: ident.name,
                loc: ident.loc
            };
        });
        state.frames.unshift(frame);
    });
    visitors.FunctionDeclaration.after = compose(function (parent, node) {
        state.frames.shift();
    }, visitors.FunctionDeclaration.after);
    visitors.Identifier.after = compose(visitors.Identifier.after, function (parent, node) {
        if (!isVariableDefined(node.name, state)) {
            state.errors.push({
                type: errorTypes_1.ErrorType.UndefinedVariable,
                node: node
            });
        }
    });
    visitors.Program.after = function (parent, node) {
        state.stopped = true;
    };
    return visitors;
};
var getAllowedSyntaxTypes = function getAllowedSyntaxTypes(week) {
    return Object.keys(syntaxTypes).reduce(function (acc, type) {
        if (syntaxTypes[type] <= week) {
            acc.push(type);
        }
        return acc;
    }, []);
};
var createParserOptions = function createParserOptions(filename, state) {
    return {
        sourceType: 'script',
        ecmaVersion: 5,
        locations: true,
        onInsertedSemicolon: function onInsertedSemicolon(_end, loc) {
            var node = {
                type: 'Statement',
                loc: {
                    end: { line: loc.line, column: loc.column + 1 },
                    start: loc
                }
            };
            state.errors.push({
                type: errorTypes_1.ErrorType.MissingSemicolon,
                node: node
            });
        },
        onTrailingComma: function onTrailingComma(end, loc) {
            var node = {
                type: 'Statement',
                loc: loc
            };
            state.errors.push({
                type: errorTypes_1.ErrorType.TrailingComma,
                node: node
            });
        },

        onComment: state.comments
    };
};
exports.parse = function (source, week) {
    var filename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';
    var previousState = arguments[3];

    var initialFrame = {};
    var state = previousState || {
        node: undefined,
        stopped: false,
        errors: [],
        comments: [],
        frames: [initialFrame],
        environments: {
            '*': initialFrame
        }
    };
    state.stopped = false;
    try {
        var program = acorn_1.parse(source, createParserOptions(filename, state));
        var visitors = createVisitors(week, state);
        var generator = visitors_1.visitProgram(program, visitors);
        while (!state.stopped) {
            generator.next();
        }
        state.node = program;
    } catch (error) {
        if (error instanceof SyntaxError) {
            var loc = error.loc;
            state.errors.push({
                type: errorTypes_1.ErrorType.AcornParseError,
                explanation: error.toString(),
                node: {
                    type: 'Statement',
                    loc: {
                        start: { line: loc.line, column: loc.column },
                        end: { line: loc.line, column: loc.column + 1 }
                    }
                }
            });
        } else {
            throw error;
        }
    }
    return state;
};
//# sourceMappingURL=parser.js.map


//////////////////
// WEBPACK FOOTER
// ../source-toolchain/es5/parser.js
// module id = 180
// module chunks = 3